// Generated by ReScript, PLEASE EDIT WITH CARE


function getRnrHome(param) {
  return {
          pointsSectionTitle: "एकूण रिवॉर्ड पॉइंट्स",
          pointsSectionSubtitle: "नवीन लेवलवर पोहोचा आणि रोमांचक भेटवस्तू जिंका",
          dailyRewardsHeader: "डेली रिवॉर्ड्स",
          cardCtaText: "मिळविण्यासाठी क्लिक करा",
          allRewardsClaimedTitle: "अभिनंदन",
          allRewardsClaimedText: "तुम्ही सर्व रिवॉर्ड्सवर दावा केला आहे",
          noRewardsClaimedTitle: "तुमच्याकडे आता कोणतेही रिवॉर्ड्स नाहीत",
          noRewardsClaimedText: "कृपया उद्या परत तपासा",
          rewardHistoryFooterText: "रिवॉर्ड्स आणि भेटवस्तू इतिहास",
          headerText: "पोर्टर रिवॉर्ड प्रोग्रॅम"
        };
}

function getMilestoneDetails(vehicleModel) {
  return {
          headerTitle: "जिंका " + vehicleModel,
          headerDetails: "सर्वाधिक रिवॉर्ड पॉइंट्स असलेला भागीदार अप्रतिम नवीन ट्रक जिंकेल",
          claimedText: "रिवॉर्डचा दावा केला",
          toClaimText: "तुमच्या रिवॉर्डवर दावा करा",
          footerText: "तुम्ही प्रगती केल्यावर अधिक लेवल्स उघडतील",
          milestone1: "स्टार",
          milestone2: "ब्रॉन्झ हिरो",
          milestone3: "ब्रॉन्झ सुपर स्टार",
          milestone4: "सिल्वर हिरो  ",
          milestone5: "सिल्वर सुपर स्टार",
          milestone6: "प्लॅटिनम हिरो  ",
          milestone7: "प्लॅटिनम सुपर स्टार",
          milestone8: "गोल्ड हीरो",
          milestone9: "गोल्ड सुपर स्टार",
          milestone10: "डायमंड हीरो ",
          milestone11: "डायमंड सुपर स्टार",
          milestone12: "पोर्टर हीरो",
          milestone13: "सुप्रो सुपर स्टार",
          locked: "बंद आहे"
        };
}

function getRnrCycleEnd(param) {
  return {
          greetings: " बधाई हो !",
          winLabel: " आपने जीता है ",
          winNotice: " हम आपको कॉल कर सूचित करेंगे कि ईनाम कैसे प्राप्त किया जा सकता है ",
          lossNotice: " माफ़ कीजिए। आपने इस बार कोई ईनाम नहीं जीता है। पुरस्कार जीतने के लिए कृपया अगले प्रोग्राम में बेहतर भाग लें। ",
          endTitle: " पोर्टर रिवार्ड कार्यक्रम समाप्त हो गया है । ",
          endText: " अगले प्रोग्राम की सूचना जल्द ही दी जाएगी ",
          scoreTitle: " आपका प्रदर्शन कैसा रहा देखिये ",
          totalScoreSubtext: " कूल एकत्रित पॉइंट्स ",
          customerExperienceScoreSubtext: " 5 स्टार रेटिंग के लिए ",
          orderCompletionScoreSubtext: " आर्डर पूरा करने के लिए ",
          loginActivityScoreSubtext: " लॉग इन के लिए ",
          topGiftsTitle: " कुछ शीर्ष पुरस्कार इस प्रकार हैं ",
          topPartnersTitle: " हमारे कुछ शीर्ष पार्टनर्स ये हैं ",
          partnerName: " पार्टनर का नाम",
          awardTitle: " पुरस्कार जीता "
        };
}

function getContent(param) {
  return {
          rnrHome: getRnrHome(undefined),
          rnrHistory: {
            title: "रिवॉर्ड्स",
            yesterdayRowTitle: "काल",
            rewardNavTabTitle: "डेली रिवॉर्ड्स",
            awardNavTabTitle: "लेवल भेटवस्तू"
          },
          milestoneDetails: getMilestoneDetails("महिंद्रा"),
          customerServiceRewards: {
            text1: "तुम्ही कमावले",
            text2: "चांगल्या ग्राहक सेवेसाठी"
          },
          loginActivtyRewards: {
            text1: "तुम्ही कमावले",
            text2: "लॉग-इन गतिविधि"
          },
          orderFulfillmentRewards: {
            text1: "तुम्ही कमावले",
            text2: "सर्व स्वीकृत ऑर्डर पूर्ण केल्याबद्दल"
          },
          mahindraAwards: {
            cardTitle: "जिंका महिंद्रा",
            cardText: "अधिक जाणून घेण्यासाठी दाबा",
            modalTitle: "जिंका महिंद्रा",
            modalText: "दर महिन्याला आकर्षक बक्षिसे जिंका आणि महिंद्र सुप्रोचे भव्य बक्षीस जिंका. अधिक तपशीलांसाठी दररोज तुमचे पॉइंट्स तपासा."
          },
          defaultLCVAward: {
            modalTitle: "या दिवाळीत बंपर बक्षिसे आणि इतर आकर्षक बक्षिसे जिंकण्याची संधी मिळवा!",
            modalText: ""
          },
          defaultHCVAward: {
            modalTitle: "या दिवाळीत बंपर बक्षिसे आणि इतर आकर्षक बक्षिसे जिंकण्याची संधी मिळवा!",
            modalText: ""
          },
          default2WAward: {
            modalTitle: "प्रत्येक आठवड्याला आकर्षक बक्षिसे जिंका",
            modalText: ""
          },
          noAward: {
            cardTitle: "बक्षीस मिळवण्यासाठी पुढील टप्पा जलद गाठा!",
            cardText: "तुम्ही जिंकत असलेल्या बक्षिसांवर इतर भागीदारांनी दावा केला आहे.",
            modalTitle: "बक्षीस मिळवण्यासाठी पुढील टप्पा जलद गाठा!",
            modalText: "तुम्ही जिंकत असलेल्या बक्षिसांवर इतर भागीदारांनी दावा केला आहे. बक्षिसे जिंकण्यासाठी पुढचा टप्पा लवकर गाठा."
          },
          insuranceAward: {
            cardTitle: "तुम्ही वाहन विम्यावर सूट मिळवली आहे",
            modalTitle: "हुर्रे! तुम्ही वाहन विम्यावर सूट मिळवली आहे"
          },
          distributionCeremonyAward: {
            cardTitle: "तुम्ही पोर्टरकडून आकर्षक बक्षिसे जिंकण्यास पात्र आहात.",
            cardText: "उत्कृष्ट कामगिरी करणाऱ्या भागीदारांना तुमच्या शहरात आयोजित कार्यक्रमात आकर्षक बक्षिसे मिळतील.|",
            modalTitle: "तुम्ही पोर्टरकडून आकर्षक बक्षिसे जिंकण्यास पात्र आहात.",
            modalText: "उत्कृष्ट कामगिरी करणाऱ्या भागीदारांना तुमच्या शहरात आयोजित कार्यक्रमात आकर्षक बक्षिसे मिळतील.|"
          },
          finalAward: {
            cardTitle: "तुम्ही पोर्टरकडून \"महिंद्रा सुप्रो\" गाड़ी जिंकण्यासाठी पात्र आहात.",
            cardText: "संपूर्ण भारतातील एक सर्वोत्तम कामगिरी करणारा भागीदार जिंकेल.",
            modalTitle: "तुम्ही पोर्टरकडून \"महिंद्रा सुप्रो\" गाड़ी जिंकण्यासाठी पात्र आहात.",
            modalText: "संपूर्ण भारतातील एक सर्वोत्तम कामगिरी करणारा भागीदार जिंकेल."
          },
          couponAward: {
            couponText: "कूपन",
            redeemTitle: "डिस्काउंट लेने का तरीका",
            detailsText: "विवरण",
            tncText: "नियम एवं शर्तें",
            codeAckTitle: "कूपन कोड कॉपी किया गया"
          },
          status: {
            loading: "लोड होत आहे",
            internetNotConnected: "इंटरनेट कनेक्ट केलेले नाही",
            tapToRetry: "पुन्हा प्रयत्न करण्यासाठी दाबा",
            ise: "काही समस्या झालीआहे",
            loadingFailed: "लोड करणे अयशस्वी"
          },
          category: {
            customerService: "ग्राहक सेवा",
            loginHours: "लॉग-इन गतिविधि",
            orderFulfillment: "पूर्ण केलेल्या ऑर्डर"
          },
          customerServiceDetails: {
            details1: "जेव्हा ग्राहक तुम्हाला तुमच्या भाड्यासाठी 5 स्टार रेटिंग देतात तेव्हा तुमचे ग्राहक सेवा पॉईंट्स वाढतात",
            details2: "म्हणून, तुम्ही करत असलेल्या 5 स्टार रेटिंग ऑर्डरची संख्या वाढवा.",
            sectionHeader: "5 स्टार रेटिंग कसे मिळवायचे?",
            tip1: "ग्राहकांशी नेहमी आदर आणि विनम्र वागा.",
            tip2: "ग्राहकांशी कधीही वाद घालू नका. वाद झाल्यास कॉल सेंटरची मदत घ्या.",
            tip3: "ग्राहकांचा सामान  काळजीपूर्वक हाताळा."
          },
          loginHourDetails: {
            details1: "तुम्ही जितके ऑनलाइन राहाल तितके जास्त लॉगिन गतिविधि पॉइंट तुम्हाला मिळतील.",
            tips: "टिपा",
            tip: "तुमच्या फावल्या वेळेत ऑनलाइन रहा आणि अधिक कमवा"
          },
          orderFulfillmentDetails: {
            details1: "मी पूर्ण केलेले ऑर्डर पॉइंट कसे मिळवू शकतो?",
            details2: "तुम्हाला ज्या ऑर्डर पूर्ण करायच्या आहेत फक्त त्याच स्वीकारा.",
            tip1: "ऑर्डर स्वीकारल्यानंतर कोणतीही ऑर्डर रद्द करू नका",
            tip2: "ग्राहकाला कधीही ऑर्डर रद्द करण्यास सांगू नका",
            slabTableText: "खालील टेबले पूर्ण केलेल्या ऑर्डरसाठी पॉइंट्स दर्शविते",
            slabTableCol1: "पूर्ण केलेले ऑर्डर",
            slabTableCol2: "पॉइंट्स"
          },
          miscellaneous: {
            points: "पॉइंट्स"
          },
          rnrCycleEnd: getRnrCycleEnd(undefined),
          getExpiryDateTitle: (function (date) {
              return "" + date + " पर्यंत कालबाह्य होईल";
            }),
          getExpiringDateTitle: (function (date) {
              return "वैद्यता समाप्ति की तारीख " + date;
            }),
          getExpiryHoursTitle: (function (hours) {
              return "" + hours + " में समाप्त हो जाएगा";
            }),
          getCurrentMilestoneText: (function (currentMilestone) {
              return "तुम्ही एक " + currentMilestone + " आहात";
            }),
          getNextMilestoneText: (function (points, nextMilestone) {
              return "" + nextMilestone + " बनण्यासाठी " + points + " पॉइंट्स की जरुरत आहे";
            }),
          getCustomerServiceRewardsText: (function (qualifiedOrders) {
              return " " + qualifiedOrders + " पांच स्टार भाडें ";
            }),
          getOrderFulfillmentRewardsText: (function (completedOrders, _requiredOrders) {
              return " तुम्ही " + completedOrders + " ऑर्डर पूर्ण केल्या आहेत ";
            }),
          getLoginActivtyRewardsText: (function (loginHours) {
              return "रेवार्डेड लॉगिन तास " + loginHours;
            }),
          getLoginRewardsDetailsText: (function (points) {
              return "तुमच्याकडे " + points + " लॉग-इन गतिविधि पॉइंट्स आहेत";
            }),
          getCustomerServiceRewardsDetailsText: (function (points) {
              return "तुमच्याकडे " + points + " ग्राहक सेवा पॉइंट्स आहेत";
            }),
          getNextMilestoneSubText: (function (points) {
              return "" + points + " पॉइंट्स दूर";
            }),
          getCustomerServicePer5StarOrderPoints: (function (points) {
              return " तुम्हाला प्रत्येक 5 स्टार ऑर्डरसाठी " + points + " पॉईंट्स मिळतात ";
            }),
          getLoginHourRewardsDetailsText: (function (startTime, endTime) {
              return "" + startTime + " ते " + endTime + " ऑनलाइन राहिल्याने तुमचे लॉग-इन गतिविधि पॉइंट्स वाढतील";
            }),
          getLoginHourRewardsLoginWindowTip: (function (startTime, endTime) {
              return "" + startTime + " AM ते " + endTime + " PM दरम्यान अधिक ऑनलाइन राहण्याचा प्रयत्न करा";
            }),
          getLoginHourRewardsPerHourPointsTip: (function (points) {
              return " लॉग इन केलेल्या प्रत्येक तासाला " + points + " पॉइंट असतात. अधिक लॉगिन म्हणजे अधिक पॉइंट्स  ";
            }),
          getOrderFullfillmentRewardsDetailsText: (function (points) {
              return "केलेल्या  भाड्यासाठी तुमच्याकडे " + points + " पॉइंट आहेत ";
            }),
          getOrderFullfillmentDailyMaxPointsTip: (function (points) {
              return "तुम्ही दररोज फक्त " + points + " पॉइंट मिऑर्डर स्वीकारल्यानंतर कोणतीही ऑर्डर रद्द करू नकाळवू शकता ";
            }),
          getMilestonePointsRemaining: (function (points) {
              return " " + points + " पॉइंट्स आवश्यक आहेत ";
            }),
          getLastSlabText: (function (orders) {
              return "" + orders + " किंवा अधिक ";
            }),
          getFuelAwardCardTitle: (function (fuelQuantity) {
              return " तुम्ही " + fuelQuantity + " लिटर इंधन जिंकले आहे ";
            }),
          getFuelAwardCardText: (function (fuelMoney) {
              return " तुमच्या वॉलेटमध्ये " + fuelMoney + " रूपये जमा झाले आहेत ";
            }),
          getFuelAwardModalTitle: (function (fuelQuantity) {
              return " हुर्रे! तुम्ही " + fuelQuantity + " लिटर इंधन जिंकले आहे ";
            }),
          getFuelAwardModalText: (function (fuelMoney) {
              return " तुमच्या वॉलेटमध्ये " + fuelMoney + " रूपये ची समतुल्य रक्कम जमा झाली आहे ";
            }),
          getPremiumnessAwardCardTitle: (function (acceptAdvantage) {
              return " ऑर्डर दरम्यान " + acceptAdvantage + " सेकंदांचा विलंब नाही! ";
            }),
          getPremiumnessAwardCardText: (function (acceptAdvantage, endDate) {
              return " तुम्हाला यापुढे " + endDate + " पर्यंत ऑर्डर दरम्यान " + acceptAdvantage + " सेकंदांचा विलंब सहन करावा लागणार नाही ";
            }),
          getPremiumnessAwardModalTitle: (function (acceptAdvantage) {
              return " हुर्रे!! ऑर्डर दरम्यान " + acceptAdvantage + " सेकंदांचा विलंब नाही! ";
            }),
          getPremiumnessAwardModalText: (function (acceptAdvantage, startDate, endDate) {
              return " तुम्ही पोर्टर प्रीमियम पार्टनर पुरस्कार जिंकला आहे. तुम्हाला यापुढे ऑर्डरमध्ये खाली नमूद केलेल्या तारखांमध्ये " + acceptAdvantage + " सेकंदांचा विलंब होणार नाही.\n        प्रारंभ तारीख - " + startDate + "\n        शेवटची तारीख - " + endDate + " ";
            }),
          getMonetaryAwardCardTitle: (function (amount) {
              return " तुम्ही ₹ " + amount + " जिंकले आहेत ";
            }),
          getMonetaryAwardCardText: (function (amount) {
              return " जिंकलेले ₹ " + amount + " तुमच्या वॉलेटमध्ये जमा झाले आहे ";
            }),
          getMonetaryAwardModalTitle: (function (amount) {
              return " हुर्रे!! तुम्ही ₹ " + amount + " जिंकले आहेत ";
            }),
          getMonetaryAwardModalText: (function (amount) {
              return " जिंकलेले ₹ " + amount + " तुमच्या वॉलेटमध्ये जमा झाले आहे ";
            }),
          getInsuranceAwardCardText: (function (price, endDate) {
              return " तुम्ही पोर्टरकडून फक्त ₹ " + price + " मध्ये विमा गोळा करू शकता!! " + endDate + " पर्यंत वैध.";
            }),
          getInsuranceAwardModalText: (function (price, endDate) {
              return " तुम्ही पोर्टरकडून फक्त ₹ " + price + " मध्ये विमा गोळा करू शकता!! " + endDate + " पर्यंत वैध.";
            }),
          getInsuranceAwardCardDiscountText: (function (discount, endDate) {
              return " आपने पोर्टर से वाहन बीमा पर ₹ " + discount + " रुपये की छूट का ईनाम जीता है। वैधता " + endDate + " तक ।";
            }),
          getInsuranceAwardModalDiscountText: (function (discount, endDate) {
              return " आपने पोर्टर से वाहन बीमा पर ₹ " + discount + " रुपये की छूट का ईनाम जीता है। वैधता " + endDate + " तक ।";
            }),
          getRewardMultiplierAwardCardTitle: (function (multiplier) {
              return " तुम्ही " + multiplier + " रिवॉर्ड पॉइंट जिंकाल ";
            }),
          getRewardMultiplierAwardCardText: (function (multiplier, startDate, endDate) {
              return " तुम्ही " + startDate + " पासून तुम्ही कॅटेगोरीमध्ये " + multiplier + " रिवॉर्ड पॉइंट जिंकाल. वैधता " + endDate + " पर्यंत ";
            }),
          getRewardMultiplierAwardModalTitle: (function (multiplier) {
              return " हुर्रे! तुम्ही " + multiplier + " रिवॉर्ड पॉइंट जिंकाल ";
            }),
          getRewardMultiplierAwardModalText: (function (multiplier, startDate, endDate) {
              return " तुम्ही " + startDate + " पासून तुम्ही कॅटेगोरीमध्ये " + multiplier + " रिवॉर्ड पॉइंट जिंकाल. वैधता " + endDate + " पर्यंत ";
            }),
          getTopGiftCardSubtext: (function (recipient_cnt) {
              return " " + recipient_cnt + " पार्टनर्स को सम्मानित किया गया ";
            })
        };
}

var Marathi = {
  getContent: getContent
};

export {
  Marathi ,
  
}
/* No side effect */
